import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { jobInputItemsClearStore } from 'reducers/jobInputItemsAdmin/reducer'
import JobInputList from './JobInputList'
import JobSingleInput from './JobSingleInput/JobSingleInput'

function JobInputs(props) {
  const {
    match: {
      params: { id },
    },
    jobInputItemsClearStore,
  } = props

  useEffect(
    () => () => {
      jobInputItemsClearStore()
    },
    [],
  )

  return (
    <div className="content">
      {id ? <JobSingleInput {...props} /> : <JobInputList {...props} />}
    </div>
  )
}

JobInputs.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  jobInputItemsClearStore: PropTypes.func.isRequired,
}

export default connect(null, {
  jobInputItemsClearStore,
})(JobInputs)
